export const WIDGET_EVENTS = [
  'availability:change',
  'campaign:triggered',
  'conversation:ended',
  'conversation:started',
  'customer:onboarded',
  'message:received',
  'message:sent',
  'quick-action:selected',
  'sidekick:closed',
  'sidekick:opened',
] as const;

export type WidgetEventName = (typeof WIDGET_EVENTS)[number];
